<template>
	<div class="hqa">
		<span
			v-if="client"
			class="hqa-static"
			:title="lastStaticFull || 'Static never generated'"
		>
			<i class="fab fa-html5 hqa-static__icon"></i>
			<span>{{ client.last_static_generated_at ? lastStaticHuman : 'never' }}</span>
		</span>

		<button
			type="button"
			class="hqa-generate"
			:class="{ 'hqa-generate--running': generating, 'hqa-generate--done': justFinished }"
			:disabled="generating || !client"
			:title="generating ? 'Generating full static…' : 'Generate Full Static'"
			@click="generateStatic"
		>
			<template v-if="generating">
				<span class="spinner-border spinner-border-sm hqa-generate__spinner" role="status"></span>
				<span>{{ seconds }}s</span>
			</template>
			<template v-else-if="justFinished">
				<i class="fas fa-check"></i>
				<span>{{ lastElapsed }}s</span>
			</template>
			<template v-else>
				<i class="fas fa-hammer"></i>
				<span>Static</span>
			</template>
		</button>

		<a
			:href="dashboardLoginUrl"
			target="_blank"
			class="hqa-link"
			:class="{ 'hqa-link--disabled': !client }"
			:title="dashboardLoginTitle"
		>
			<i class="fad fa-fingerprint"></i>
			<span>{{ isUnified ? 'Unified Dashboard' : 'Dashboard' }}</span>
		</a>

		<a
			:href="websiteUrl"
			target="_blank"
			class="hqa-link"
			:class="{ 'hqa-link--disabled': !client }"
			title="Visit Website"
		>
			<i class="fad fa-globe"></i>
			<span>Website</span>
		</a>
	</div>
</template>

<script>
import clientQuickActions from '@/mixins/clientQuickActions'

/**
 * Compact quick-actions strip rendered inside JuniperPageHeader on every
 * client edit route. Same logic as the floating widget via the shared mixin.
 */
export default {
	name: 'ClientHeaderQuickActions',
	mixins: [clientQuickActions],
}
</script>

<style scoped>
.hqa {
	display: flex;
	align-items: center;
	gap: 8px;
}

.hqa-static {
	display: inline-flex;
	align-items: center;
	gap: 5px;
	font-size: 12px;
	color: #6b7280;
	cursor: default;
	white-space: nowrap;
}

.hqa-static__icon {
	color: #9ca3af;
	font-size: 12px;
}

.hqa-generate {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 7px 12px;
	border: none;
	border-radius: 999px;
	background: #f97316;
	color: #ffffff;
	font-size: 12px;
	font-weight: 600;
	cursor: pointer;
	transition: background 0.15s ease;
	white-space: nowrap;
}

.hqa-generate:hover:not(:disabled) {
	background: #ea580c;
}

.hqa-generate--running {
	background: #ffedd5;
	color: #f97316;
	cursor: default;
}

.hqa-generate--running:disabled {
	opacity: 1;
}

.hqa-generate--done {
	background: #dcfce7;
	color: #16a34a;
}

.hqa-generate__spinner {
	width: 12px;
	height: 12px;
	border-width: 2px;
}

.hqa-link {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 7px 12px;
	border: 1px solid #e0e1e1;
	border-radius: 999px;
	background: #ffffff;
	color: #64748b;
	font-size: 12px;
	font-weight: 600;
	text-decoration: none;
	transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
	white-space: nowrap;
}

.hqa-link:hover {
	background: #f8f9fa;
	border-color: #d1d5db;
	color: #475569;
	text-decoration: none;
}

.hqa-link--disabled {
	pointer-events: none;
	opacity: 0.5;
}

.hqa-link i,
.hqa-generate i {
	font-size: 12px;
}
</style>
